export const creditCardNumberFormatStrategy = (value: string) => {
  return !!value.match('[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}');
};
